import { ReactNode } from "react";
import { FieldPath, FieldPathValue, FieldValues, useWatch } from "react-hook-form";

type Props<TFieldValues extends FieldValues, TFieldName extends FieldPath<TFieldValues>> = {
    name: TFieldName;
    render: (value: FieldPathValue<TFieldValues, TFieldName>) => ReactNode;
};

export const Watch = <TFieldValues extends FieldValues, TFieldName extends FieldPath<TFieldValues>>({
    name,
    render,
}: Props<TFieldValues, TFieldName>) => {
    const value = useWatch<TFieldValues, TFieldName>({ name });
    return <>{render(value)}</>;
};
